import React from "react";
import infoIcon from "../../content/images/info-icon.svg";
import { formserverBaseURL } from "../../utilities";

const InfoIcon = ({ onClick, active = false }) => {
  return (
    <div className="info-icon-wrapper">
      <img
        alt="Info Icon"
        onClick={onClick}
        src={formserverBaseURL + infoIcon}
        className={`info-icon ${active && "info-icon__active"}`}
      />
    </div>
  );
};

export default InfoIcon;
